import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function CancelIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="10.547" height="10.547" viewBox="0 0 10.547 10.547" {...props}>
      <defs>
        <style>
          {`.cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_1802" transform="translate(-854.313 -495.425)">
        <path id="Line_326" d="M0 0L11.095 0" class="cls-1" transform="translate(855.575 496.889) rotate(45)"/>
        <path id="Line_328" d="M0 0L0 11.415" class="cls-1" transform="translate(863.623 496.663) rotate(45)"/>
      </g>
    </SvgIcon>
  );
}

export default CancelIcon;


// WEBPACK FOOTER //
// ./src/components/icons/CancelIcon.jsx